export * from './room-image';
